<div class="absolute inset-0 flex flex-col min-w-0 overflow-hidden">

    <mat-drawer-container class="flex-auto h-full">

        <!-- Drawer -->
        <mat-drawer
            class="w-72 dark:bg-gray-900"
            [autoFocus]="false"
            [mode]="'over'"
            [position]="'end'"
            #matDrawer>
            <!-- Demo sidebar -->
            <div class="py-10">
                <!-- Fixed demo sidebar -->
                <div class="mx-6 text-3xl font-bold tracking-tighter">Additional Options</div>
                <button mat-menu-item aria-label="Open In ACD"
                        (click)="goToDigitalTagsACD()">
                    <mat-icon>open_in_new</mat-icon>
                    <span>Open In ACD</span>
                </button>
                <a  mat-menu-item href="data:application/octet-stream,Title%2CHexColor%0ATag%20Title%2COnly%20values%20Supported%20%0ASummer%20Forest%20Green%2C%23289D29%0AStoplight%2C%23E11616%0AMikado%20Yellow%2C%23FFC20A%0AMagical%20Merlin%2C%232E8FCE%0ATabasco%2C%23982910%0AMagenta%20Fizz%2C%23DF23E6%0AOrb%20of%20Discord%2C%2385289D%0APigeon%2C%23ADADAD%0AIce%20Climber%2C%231DD6D4%0AFernweh%2C%239D7D28" download="Batch Digital Tag Template.csv">
                    <mat-icon>cloud_download</mat-icon> Download Template
                </a>
                <input type="file" id="fileInput" multiple style="display: none;" (change)="onFilesSelected($event)">
                <button mat-menu-item aria-label="Upload Bulk Template"
                        onclick="document.getElementById('fileInput').click();">
                    <mat-icon>cloud_upload</mat-icon>
                    <span>Upload Bulk Template</span>
                </button>

                <!-- Title -->
                <div class="mx-6 mt-2">
                    <div class="flex items-center">
                        <mat-icon
                            class="mr-2 icon-size-5"
                            [svgIcon]="'heroicons_outline:location-marker'"></mat-icon>
                        <div class="text-lg font-semibold">New Tag</div>
                    </div>
                </div>




                <div class="mx-6 mt-2">
                    <div class="flex items-center">
                        <div class="w-full">
                            <form [formGroup]="tagForm">
                                <!-- Contact Name -->
                                <div class="mt-3 flex-grow">
                                    <mat-form-field class="fuse-mat-no-subscript w-full">
                                        <mat-label>Tag Title</mat-label>
                                        <mat-icon
                                            matPrefix
                                            class="hidden sm:flex icon-size-5"
                                            [svgIcon]="'heroicons_solid:menu-alt-2'"></mat-icon>
                                        <input
                                            matInput
                                            [formControlName]="'newTagTitle'"
                                            [placeholder]="'Tag Title'"
                                        >
                                    </mat-form-field>
                                </div>
                                <div class="mt-3" >
                                    <mat-form-field class="fuse-mat-no-subscript w-full">
                                        <mat-label>Color</mat-label>
                                        <mat-icon
                                            matPrefix
                                            class="hidden sm:flex icon-size-5"
                                            [svgIcon]="'heroicons_solid:menu-alt-2'"></mat-icon>
                                        <mat-select required formControlName="newTagColor">
                                            <mat-option value="#289D29" style="background: #289D29" >#289D29 Summer Forest Green</mat-option>
                                            <mat-option value="#E11616" style="background: #E11616" >#E11616 Stoplight</mat-option>
                                            <mat-option value="#FFC20A" style="background: #FFC20A" >#FFC20A Mikado Yellow</mat-option>
                                            <mat-option value="#2E8FCE" style="background: #2E8FCE" >#2E8FCE Magical Merlin</mat-option>
                                            <mat-option value="#982910" style="background: #982910" >#982910 Tabasco</mat-option>
                                            <mat-option value="#DF23E6" style="background: #DF23E6" >#DF23E6 Magenta Fizz</mat-option>
                                            <mat-option value="#85289D" style="background: #85289D" >#85289D Orb of Discord</mat-option>
                                            <mat-option value="#ADADAD" style="background: #ADADAD" >#ADADAD Pigeon</mat-option>
                                            <mat-option value="#1DD6D4" style="background: #1DD6D4" >#1DD6D4 Ice Climber</mat-option>
                                            <mat-option value="#9D7D28" style="background: #9D7D28" >#9D7D28 Fernweh</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <!-- Add product button -->
                <button
                    class="ml-30"
                    mat-flat-button
                    [color]="'primary'"
                    (click)="addTag()">
                    <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                    <span class="ml-2 mr-1">Add Tag</span>
                </button>
            </div>

        </mat-drawer>

        <!-- Drawer content -->
        <mat-drawer-content class="flex flex-col">



            <!-- Header -->
            <div class="flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between p-6 pb-6 sm:pt-12 sm:pb-6 sm:px-10 bg-default dark:bg-transparent">
                <div class="flex-1 min-w-0">
                    <!-- Breadcrumbs -->
                    <div>
                        <div class="hidden sm:flex flex-wrap items-center font-medium">
                            <div>
                                <a class="whitespace-nowrap text-primary-500">Skills/Queues</a>
                            </div>
                        </div>
                        <div class="flex sm:hidden">
                            <a
                                class="inline-flex items-center -ml-1.5 text-secondary font-medium"
                                [routerLink]="'./..'">
                                <mat-icon
                                    class="icon-size-5 text-secondary"
                                    [svgIcon]="'heroicons_solid:chevron-left'"></mat-icon>
                                <span class="ml-1">Back</span>
                            </a>
                        </div>
                    </div>
                    <!-- Title -->
                    <div class="mt-2">

                        <h2 class="text-3xl md:text-4xl font-extrabold tracking-tight leading-7 sm:leading-10 truncate">
                            <mat-icon class="logo-icon s-32 mr-16">
                                check_circle_outline
                            </mat-icon>
                            Digital Tags
                        </h2>
                    </div>
                </div>
                <!-- Actions -->
                <div class="flex shrink-0 items-center mt-6 sm:mt-0 sm:ml-4">
                    <mat-form-field
                        class="fuse-mat-no-subscript w-full sm:w-72 mt-4 sm:mt-0 sm:ml-4"
                        [floatLabel]="'always'">
                        <mat-icon
                            matPrefix
                            class="icon-size-5"
                            [svgIcon]="'heroicons_solid:search'"></mat-icon>
                        <input
                            (keyup)="applyFilter($event)"
                            placeholder="Search Tags"
                            matInput
                            [value]="filterValue"
                            >
                    </mat-form-field>
                    <button
                        mat-icon-button
                        (click)="matDrawer.toggle()">
                        <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
                    </button>
                </div>
            </div>

            <!-- Main -->
            <div class="flex flex-col flex-auto p-6 bg-card overflow-hidden sm:overflow-y-auto">
                <!-- CONTENT GOES HERE -->
                <div class="overflow-y-scroll">
                    <mat-table
                        #table
                        [dataSource]="dataSource"
                        matSort >
                        <ng-container matColumnDef="id">
                            <mat-header-cell *matHeaderCellDef mat-sort-header>Id</mat-header-cell>
                            <mat-cell *matCellDef="let row">
                                {{row.id}}
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="title">
                            <mat-header-cell *matHeaderCellDef mat-sort-header>Title</mat-header-cell>
                            <mat-cell *matCellDef="let row">
                                <input class="inline-text-input" type="text"
                                *ngIf="editTagId === row.id"
                                [(ngModel)]="row.title"
                                [placeholder]="row.title">
                         <span *ngIf="editTagId !== row.id"
                               class="text-truncate inline-editable">
                     {{row.title}} </span>
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="color" >
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Color</mat-header-cell>
                            <mat-cell *matCellDef="let row" >
                                <input type="color" value="{{row.color}}" disabled />{{row.color}}
                            </mat-cell>
                        </ng-container>
                        <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>

                        <ng-container matColumnDef="inlineEdit">
                            <mat-header-cell *matHeaderCellDef class="max-w-[75px]"></mat-header-cell>
                            <mat-cell *matCellDef="let row" class="max-w-[75px] cursor-pointer" (click)="$event.stopPropagation();">
                                <mat-icon color="accent" *ngIf="editTagId !== row.id" (click)="$event.stopPropagation(); beginInlineEdit(row)">edit</mat-icon>
                                <mat-icon color="warn" *ngIf="editTagId === row.id" (click)="$event.stopPropagation(); cancelInLineEdit()">cancel</mat-icon>
                                <mat-icon color="primary" *ngIf="editTagId === row.id" (click)="$event.stopPropagation(); saveInLineEdit(row)">save</mat-icon>
                            </mat-cell>
                        </ng-container>

                        <mat-row *matRowDef="let code; columns: displayedColumns;"
                                 class="product"
                                 matRipple>
                        </mat-row>
                    </mat-table>
                </div>
                <mat-paginator [length]="dataSource.filteredData.length"
                               [pageSize]="25"
                               [pageSizeOptions]="[10, 25]"
                >
                </mat-paginator>
            </div>
        </mat-drawer-content>

    </mat-drawer-container>

</div>
